// ============================================================
// Davetler — kurumun kendi kullanıcı yönetimi
//
// Google/Apple ile giriş herkese açık; kim ne görecek bunu DAVET
// belirliyor. Bu ekrandan önce davet yalnızca terminalden
// oluşturulabiliyordu (npm run davet), yani bir kreş yöneticisi
// kendi personelini bile ekleyemiyordu.
//
// Kiracı kimliği buradan GÖNDERİLMEZ — sunucu onu çağıranın
// claim'inden alıyor (functions/index.js → davetEt). İstemcinin
// göndermesine izin verilseydi bir kreş başka kreşe personel
// davet edebilirdi.
// ============================================================

import { card, emptyNote, sectionTitle } from "../components/ui.js";
import { esc } from "../lib/fmt.js";
import { ROLLER, rol } from "../domain/auth.js";
import { firebaseHazir } from "../config.js";
import { rerender } from "../lib/rerender.js";

let onbellek = null;
let yukleniyor = false;
let hata = null;

// Yönetici müdür atayabilir, müdür atayamaz — yetki yükseltme
// yolu açılmasın. Sunucu da aynı kuralı uyguluyor.
const DAVET_EDILEBILIR = {
  yonetici: ["mudur", "egitmen", "mutfak", "servis", "veli"],
  mudur: ["egitmen", "mutfak", "servis", "veli"],
};

export const davetEdebilir = () => Boolean(DAVET_EDILEBILIR[rol()]);

async function yukle() {
  if (yukleniyor) return;
  yukleniyor = true;
  hata = null;
  try {
    const { davetleriOku } = await import("../domain/firebase-auth.js");
    onbellek = await davetleriOku();
  } catch (e) {
    hata = e.message;
    onbellek = [];
  } finally {
    yukleniyor = false;
    rerender();
  }
}

export function davetleriTazele() {
  onbellek = null;
  yukle();
}

const DURUM = {
  bekliyor:   { label: "Davet bekliyor", chip: "bg-sun-soft text-[#B07E14]" },
  kullanildi: { label: "Aktif",          chip: "bg-teal-soft text-teal" },
  iptal:      { label: "İptal",          chip: "bg-line text-inksoft" },
};

export function davetKarti(subeId) {
  if (!davetEdebilir()) return "";

  if (!firebaseHazir) {
    return card(`
      <div class="p-5">
        ${sectionTitle("Kullanıcılar & Davetler")}
        ${emptyNote("Davetler yalnızca gerçek kurulumda çalışır — bu tarayıcıda demo veri var.")}
      </div>`, "min-w-0 lg:col-span-2");
  }

  if (onbellek === null) {
    yukle();
    return card(`<div class="p-5">${sectionTitle("Kullanıcılar & Davetler")}
      <p class="text-sm text-inksoft">Yükleniyor…</p></div>`, "min-w-0 lg:col-span-2");
  }

  const roller = DAVET_EDILEBILIR[rol()] ?? [];

  return card(`
    <div class="p-5">
      ${sectionTitle("Kullanıcılar & Davetler",
        `<span class="text-[11px] text-inksoft hidden sm:block">${onbellek.length} kayıt</span>`)}

      <p class="text-[11px] text-inksoft mb-4 leading-relaxed">
        Davet ettiğiniz kişi <strong>bu e-posta adresiyle</strong> Google veya
        Apple hesabından giriş yaptığında hesabı kendiliğinden açılır. Adres
        tutmazsa giriş yapar ama hiçbir şey göremez.
      </p>

      <form data-davet-form class="grid gap-2 sm:grid-cols-[1fr_1fr_auto] mb-4">
        <input name="email" type="email" required placeholder="e-posta"
          class="rounded-xl border border-line px-3 py-2 text-sm">
        <select name="role" class="rounded-xl border border-line px-3 py-2 text-sm">
          ${roller.map(r => `<option value="${r}">${esc(ROLLER[r]?.label ?? r)}</option>`).join("")}
        </select>
        <button type="submit" data-sube="${esc(subeId)}"
          class="rounded-xl bg-grape text-white font-semibold text-sm px-4 py-2 hover:opacity-90 transition">
          Davet et
        </button>
      </form>
      <p data-davet-durum class="hidden text-sm font-semibold mb-3"></p>

      ${onbellek.length ? `
      <div class="overflow-x-auto">
        <table class="w-full text-sm min-w-[520px]">
          <thead><tr class="text-left text-[11px] uppercase tracking-wide text-inksoft border-b border-line">
            <th class="py-2.5 pr-4">E-posta</th><th class="py-2.5 pr-4">Rol</th>
            <th class="py-2.5 pr-4">Durum</th><th class="py-2.5"></th>
          </tr></thead>
          <tbody class="divide-y divide-line/70">
            ${onbellek.map(d => {
              const dur = DURUM[d.status] ?? DURUM.bekliyor;
              return `<tr>
                <td class="py-2.5 pr-4 truncate max-w-[240px]">${esc(d.email)}</td>
                <td class="py-2.5 pr-4">${esc(ROLLER[d.role]?.label ?? d.role)}</td>
                <td class="py-2.5 pr-4">
                  <span class="text-[10px] font-bold rounded-full px-2 py-0.5 ${dur.chip}">${dur.label}</span>
                </td>
                <td class="py-2.5 text-right">
                  ${d.status === "iptal" || d.role === "yonetici" ? "" : `
                    <button data-davet-iptal="${esc(d.email)}"
                      class="text-[11px] font-semibold text-coral hover:underline">Erişimi kes</button>`}
                </td>
              </tr>`;
            }).join("")}
          </tbody>
        </table>
      </div>` : emptyNote("Henüz davet yok.")}

      ${hata ? `<p class="text-sm text-coral font-semibold mt-3">${esc(hata)}</p>` : ""}
    </div>`, "min-w-0 lg:col-span-2");
}
